<template>
  <div>
    <div v-if="groups.length != 0">
      <div
        :class="!$vuetify.breakpoint.xsOnly ? 'px-md-5' : ''"
        v-if="userId === null || groups.length !== 0"
      >
        <v-card elevation="0" color="#f2f8ff" class="my-1">
          <v-card-text class="px-0">
            <div class="d-flex justify-space-between">
              <div v-if="$featureFlags.groups" class="heading__class">
                <span v-if="userId === null">Groups created by you</span>
                <span v-else>Groups</span>
              </div>
              <div class="d-flex">
                <div>
                  <v-btn
                    v-if="!$vuetify.breakpoint.xsOnly"
                    @click="openViewAll()"
                    class="viewAll"
                    height="42px"
                    color="primary"
                    outlined
                    >View All Groups</v-btn
                  >
                </div>

                <group-create-btn
                  class="ml-3"
                  v-if="userId === null"
                  :profile_object="profile_object"
                ></group-create-btn>
              </div>
            </div>
            <!-- <div class="success--text pb-2" v-if="is_superuser && userId === null">
          Note: Now you are eligible to create Premium Groups
        </div> -->

            <div
              v-if="$featureFlags.groups"
              :class="
                !$vuetify.breakpoint.xsOnly
                  ? 'd-flex overflow-x-auto overflow-y-hidden'
                  : ''
              "
            >
              <v-row class="ma-0" v-if="loading">
                <v-col cols="12" md="4" sm="12" v-for="item in 3" :key="item">
                  <v-card class="mt-2">
                    <v-skeleton-loader
                      :type="
                        $vuetify.breakpoint.xsOnly
                          ? 'article'
                          : 'image, article'
                      "
                    />
                  </v-card>
                </v-col>
              </v-row>
              <div :class="!$vuetify.breakpoint.xsOnly ? 'my-5' : ''">
                <group-horizontal-list
                  :sameUser="same_user"
                  :groups="groups"
                ></group-horizontal-list>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <div
      v-else
      :class="$vuetify.breakpoint.smAndUp ? 'mx-5 mb-5' : 'mx-0 my-5'"
    >
      <v-card>
        <v-card-text>
          <myprofile-no-groups> </myprofile-no-groups>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import GroupCreateBtn from "./GroupCreateBtn.vue";
// import GroupHorizontalList from "./GroupHorizontalList.vue";
import GroupHorizontalList from "./MyGroupProfileHorizontalList.vue";

// import GroupSkeletonLoader from "./GroupSkeletonLoader.vue";
// import commonFunctions from "@/common/commonFunctions";
import commonFunctions from "@/common/commonFunctions";

import { mapGetters } from "vuex";
import MyprofileNoGroups from "./Group/MyprofileNoGroups.vue";
export default {
  props: {
    userId: {
      type: String,
      default: null,
    },
    profile_object: {
      type: Object,
      default: null,
    },
  },

  components: { GroupCreateBtn, GroupHorizontalList, MyprofileNoGroups },

  data: () => ({
    loading: false,
    commonFun: commonFunctions,

    // is_superuser: false,
  }),

  async created() {
    this.loading = true;
    if (this.userId === null) {
      await this.$store.dispatch("groups/fetchOwnGroups");
    } else {
      await this.$store.dispatch("groups/fetchUserGroups", {
        userId: this.userId,
      });
    }
    this.loading = false;

    this.eventBus.$on("refresh-group-list", () => {
      this.$store.dispatch("groups/fetchOwnGroups");
    });
  },
  beforeDestroy() {
    this.eventBus.$off("refresh-group-list");
  },
  methods: {
    openViewAll() {
      this.$router.push({
        name: "allGroups",
        params: {
          id: this.$route.params.id || this.commonFun.getUserId(),
        },
      });
    },
  },

  computed: {
    ...mapGetters({
      getSuperUser: "user/getSuperUser",
    }),
    is_superuser() {
      return this.getSuperUser;
    },
    same_user() {
      return this.userId === null;
    },
    groups() {
      if (this.userId !== null) return this.$store.state.groups.userGroups;
      return this.$store.state.groups.ownGroups;
    },
  },
  mounted() {
    // this.is_superuser = commonFunctions.isSuperUser();
  },
};
</script>

<style scoped>
.viewAll {
  height: 42px;
  border-radius: 6px;
  text-transform: capitalize;
  width: 140px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: center;
}
.skeleton-loader >>> .v-skeleton-loader__avatar {
  width: 4.5rem;
  height: 4.5rem;
}
.heading__class {
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 27px;
  color: #333;
}
</style>
